<script setup lang="ts">
    import type { Component } from 'vue';
    import { LoaderCircle } from 'lucide-vue-next';

    type Props = {
        variant?: 'brand' | 'primary' | 'secondary' | 'tertiary' | 'destructive';
        size?: 'sm' | 'md' | 'lg' | 'xl';
        loading?: boolean;
        icon?: boolean;
        fullWidth?: boolean;
        disabled?: boolean;
        iconLeft?: Component;
        iconRight?: Component;
    };

    withDefaults(defineProps<Props>(), {
        variant: 'primary',
        size: 'md',
    });
</script>

<template>
    <button
        data-slot="button"
        :class="['ui-button', `ui-button--${variant}`, `ui-button--${size}`, { 'ui-button--icon': icon, 'ui-button--full-width': fullWidth, 'ui-button--loading': loading }]"
        :disabled="disabled"
        :aria-busy="loading || undefined"
    >
        <slot name="iconLeft">
            <component
                :is="iconLeft"
                v-if="iconLeft"
            />
        </slot>

        <div class="ui-button__label">
            <slot />
        </div>

        <slot name="iconRight">
            <component
                :is="iconRight"
                v-if="iconRight"
            />
        </slot>

        <div
            v-if="loading"
            class="ui-button__spinner"
        >
            <LoaderCircle />
        </div>
    </button>
</template>

<style scoped src="./button.css"></style>
